module.exports = __webpack_public_path__ + "media/images/emblems/La_Sagne-coat_of_arms-23d091e7546a3284a0d36c9d4936ed2a.svg";